import "./Service.css";
import AutoPlayMethods from "./ServiceCard";
const Service = () => {
  return (
    <div id="service">
      <h1 className="fw-bold text-center" data-aos="fade-down">
        Service
      </h1>
      <div className="text-center">
        <small>
          These are a few sample projects, and I have also built many others.
          You can check out my GitHub for more.
        </small>
      </div>
      <div className="container">
        <div className="row mx-auto w-100">
          <AutoPlayMethods />
        </div>
      </div>
    </div>
  );
};

export default Service;
